import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import { Column, Row } from 'components/layout';
import Button from 'components/button';
import StatusBanner, {
  STATUS_BANNER_TYPE_ENUM,
} from 'components/status-banner';

import styles from './error.less';

/**
 * The label of the retry button.
 * @type {string}
 */
const RETRY_BUTTON_LABEL = 'RETRY';

class Error extends Component {
  static propTypes = {
    details: PropTypes.object.isRequired, // e.g. a Stitch error object
    retryOnClick: PropTypes.func,
    retryVisible: PropTypes.bool,
    statusMessage: PropTypes.string.isRequired,
  };

  static defaultProps = {
    retryOnClick: () => {},
    retryVisible: true,
  };

  // Use local state like hoverableLayer
  state = {
    expanded: false,
  };

  toggleExpanded = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  renderErrorText() {
    const { expanded } = this.state;
    const caretName = expanded ? 'caret-down' : 'caret-right';
    return (
      <div
        data-test-id="error-container-error-text"
        className={classnames(styles.server)}
        onClick={this.toggleExpanded}
      >
        <Row gutter={false}>
          <Row
            className={classnames(styles['server-text'])}
            gutter={false}
            alignItems="center"
          >
            <span className={styles['caret-icon']}>
              <FontAwesome name={caretName} />
            </span>
            <span>Server response</span>
          </Row>
        </Row>
      </div>
    );
  }

  renderErrorDetails() {
    const { expanded } = this.state;
    const {
      details: { error_code: errorCode, error },
    } = this.props;
    return expanded ? (
      <Column gutter={false} data-test-id="error-container-error-details">
        <Row className={styles['error-code']} gutter={false}>
          {errorCode}
        </Row>
        <Row className={styles['error-text']} gutter={false}>
          {error}
        </Row>
      </Column>
    ) : null;
  }

  render() {
    const { details, retryOnClick, retryVisible, statusMessage } = this.props;
    const serverText = !isEmpty(details) ? this.renderErrorText() : null;
    const serverDetails = !isEmpty(details) ? this.renderErrorDetails() : null;

    return (
      <Fragment>
        <StatusBanner
          gutter={false}
          icon="exclamation-triangle"
          isDismissable={false}
          isVisible
          muted
          type={STATUS_BANNER_TYPE_ENUM.danger}
        >
          {statusMessage}
        </StatusBanner>

        <Row gutter={false} justifyContent="space-between">
          {serverText}

          {retryVisible && (
            <Button
              data-test-id="error-retry-button"
              size="sm"
              onClick={retryOnClick}
              className={classnames(styles.retry)}
            >
              {RETRY_BUTTON_LABEL}
            </Button>
          )}
        </Row>
        {serverDetails}
      </Fragment>
    );
  }
}

export default Error;
export { Error, RETRY_BUTTON_LABEL };
